{
  "API_ERRORS": {
    "INCORRECT_CREDENTIALS": "L'email ou le mot de passe est incorrect",
    "DEFAULT": "La connexion n'a pas abouti. Réessayez dans quelques minutes."
  },
  "LOGIN": {
    "TITLE": "Veuillez entrer vos identifiants de connexion pour continuer",
    "FORGOT_PASSWORD": "Mot de passe oublié ?",
    "FORM": {
      "EMAIL": {
        "LABEL": "Votre e-mail"
      },
      "PASSWORD": {
        "LABEL": "Votre mot de passe"
      },
      "SUBMIT": "Confirmer"
    }
  },
  "FORGOTTEN_PASSWORD": {
    "FIRST_CONNECTION_SUCCESS": {
      "TITLE": "Merci, vous y êtes presque !",
      "DESCRIPTION": "Nous vous avons envoyé les informations nécessaires à votre première connexion sur l’adresse e-mail que vous avez renseignée.<br/><br/>Si vous n’avez rien reçu, réessayez la procédure, et assurez-vous d’avoir entré une adresse e-mail correcte. Les coquilles ça arrive !"
    },
    "NORMAL_SUCCESS": {
      "TITLE": "Merci, vous y êtes presque !",
      "DESCRIPTION": "Nous vous avons envoyé vos informations de réinitialisation sur l’adresse e-mail que vous avez renseignée.<br/><br/>Si vous n’avez rien reçu, réessayez la procédure, et assurez-vous d’avoir entré une adresse e-mail correcte. Les coquilles ça arrive !"
    },
    "EXPIRED_LINK_FIRST_CONNECTION": {
      "TITLE": "Woopsie ! Il semblerait que le lien de première<br/>connexion que vous avez utilisé pour visiter<br/>cette page n’est plus valable.",
      "DESCRIPTION": "Entrez votre e-mail à nouveau, puis cliquez sur le bouton ci-dessous pour en générer un tout frais."
    },
    "EXPIRED_LINK": {
      "TITLE": "Woopsie ! Il semblerait que le lien de<br/>réinitialisation de mot de passe que vous avez<br/>utilisé pour visiter cette page n’est plus valable.",
      "DESCRIPTION": "Entrez votre e-mail à nouveau, puis cliquez sur le bouton ci-dessous pour en générer un tout frais."
    },
    "NORMAL": {
      "TITLE": "Vous avez dit mot de passe oublié ?<br/>Pas de panique, on est là",
      "DESCRIPTION": "Entrez l’email que vous utilisez habituellement pour votre compte."
    },
    "YOU_CAN_CLOSE_WINDOW": "Vous pouvez fermer cette fenêtre.",
    "BACK_TO_CONNECTION": "Retourner sur la page de connexion",
    "FORM": {
      "EMAIL_INPUT": {
        "LABEL": "Votre e-mail"
      },
      "SUBMIT": "Continuer"
    }
  },
  "COOKIES_REQUIRED": {
    "TITLE": "Il nous manque un cookie pour<br/>vous ouvrir la porte",
    "DESCRIPTION": "Votre navigateur refuse d’enregistrer le cookie de session de <b>{{origin}}</b>, et c’est lui qui prouve que vous venez de vous identifier.<br/><br/>Autorisez les cookies pour ce site, puis réessayez. En navigation privée, vérifiez aussi que le blocage des cookies n’est pas actif.",
    "BACK_TO_CONNECTION": "Retourner sur la page de connexion"
  },
  "RESET_PASSWORD": {
    "NORMAL": {
      "TITLE": "Ah, vous revoilà ! Entrez votre<br/>nouveau mot de passe <i class=\"rm-super-white\"></i> sécurisé",
      "DESCRIPTION": "C’est toujours mieux d’alterner des capitales, minuscules, et des caractères alphanumériques, mais on est sympa : on vous laisse le “champ” libre."
    },
    "NORMAL_SUCCESS": {
      "TITLE": "Votre <i class=\"rm-super-white\"></i> mot de passe<br/>a bien été mis à jour !",
      "DESCRIPTION": "Vous pouvez maintenant vous connecter en toute securité en cliquant sur le bouton ci-après."
    },
    "FIRST_CONNECTION": {
      "TITLE": "On nous dit dans l’oreillette que c’est<br/>votre première connexion ?",
      "DESCRIPTION": "Entrez donc le <i class=\"rm-super-white\"></i> mot de passe qui vous convient bien. C’est toujours mieux d’alterner des capitales, minuscules, et des caractères alphanumériques, mais on est sympa : on vous laisse le “champ” libre."
    },
    "FIRST_CONNECTION_SUCCESS": {
      "TITLE": "Votre <i class=\"rm-super-white\"></i> mot de passe<br/>a été créé avec succès !",
      "DESCRIPTION": "Vous pouvez maintenant vous connecter en toute securité en cliquant sur le bouton ci-après."
    },
    "FORM": {
      "NEW_PASSWORD": {
        "LABEL": "Votre nouveau mot de passe",
        "PASSWORD_LENGTH_ERROR": "Longueur minimum : {{minimumLength}} caractères"
      },
      "NEW_PASSWORD_CONFIRM": {
        "LABEL": "Confirmer votre mot de passe",
        "PASSWORD_ARE_NOT_THE_SAME": "Les deux mots de passe ne sont pas identiques"
      },
      "SUBMIT": "Confirmer"
    },
    "LOGIN": "Me connecter"
  }
}
